import { render } from "./CustomEcommerceDevelopment.vue?vue&type=template&id=0a98efa6&scoped=true"
import script from "./CustomEcommerceDevelopment.vue?vue&type=script&lang=js"
export * from "./CustomEcommerceDevelopment.vue?vue&type=script&lang=js"

import "./CustomEcommerceDevelopment.vue?vue&type=style&index=0&id=0a98efa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a98efa6"]])

export default __exports__